import  { useState, useEffect, useContext, useMemo } from 'react'
import { HeadingTitle } from '../../../components/modules/ui'
// import { ExportCSV, ExportXLS } from '../../../components/modules/table/ExportData'
// import ExportPDF from '../../../components/modules/table/typesExportPDF/ExportPDFEstadoResultado'
import FilterDateControl from '../../../components/modules/table/FilterDateControl'
import FilterControl from '../../../components/modules/table/FilterControl'
import TableMovimientos from './Table'

import GlobalContext from '../../../context/global-context'
import { BusinessAPI } from '../../../api/business.api'
import dayjs from 'dayjs'
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter'
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore'
// import traslation from '../../../components/modules/ui/traslation/traslationAdministracion.json'

// Extiende dayjs con plugins de comparación
dayjs.extend(isSameOrAfter)
dayjs.extend(isSameOrBefore)

export default function ListConciliacion() {
  const { ui, currentBusiness } = useContext(GlobalContext)
  const businessAPI = useMemo(() => new BusinessAPI(), [])

  // datos y filtros
  const [allData, setAllData] = useState([])
  const [bankData] = useState([])
  const [filters, setFilters] = useState({
    startDate: dayjs().startOf('month').format('YYYY-MM-DD'),
    endDate: dayjs().format('YYYY-MM-DD')
  })
  const [statusFilter, setStatusFilter] = useState('')
  const [typeFilter, setTypeFilter] = useState('')
  const [razonSocialFilter, setRazonSocialFilter] = useState('')

  // bloques de utilidades para formateo
  // const formatCLP = value => value?.toLocaleString('es-CL', { minimumFractionDigits: 0 }) ?? '-'

  // const tipoMap = {
  //   ingreso: 'Clientes',
  //   egreso: 'Proveedor',
  //   vinculos: 'Vinculación'
  // }

  // const obtenerAbreviatura = nombre => traslation.documentosContables[nombre] || nombre

  // opciones para filtro de tipo
  const typeOptions = useMemo(
    () => [
      { value: '', label: 'Todos' },
      { value: 'ingreso', label: 'Cliente' },
      { value: 'egreso', label: 'Proveedor' },
      { value: 'vinculos', label: 'Vinculación' }
    ],
    []
  )

  // años y meses
  const yearFilter = dayjs().year()
  const currentMonth = dayjs().month() + 1
  const meses = useMemo(() => Array.from({ length: currentMonth }, (_, i) => i + 1), [currentMonth])

  // carga de datos con mes actual primero
  const getData = async () => {
    if (!currentBusiness?.id) return
    const tipos = ['ingreso', 'egreso', 'vinculos']
    const allMonths = meses.map(m => String(m).padStart(2, '0'))
    const latestMonth = allMonths.pop()

    try {
      ui.setLoader({ visible: true, text: `Cargando mes ${latestMonth}...` })
      const initial = await Promise.all(
        tipos.map(tipo =>
          businessAPI
            .getListSummaryMovements({
              type: tipo,
              businessId: currentBusiness.id,
              month: latestMonth,
              year: yearFilter,
              code: null,
              linkage: true
            })
            .then(res => res.data.map(item => ({ ...item, types: tipo })))
        )
      )
      setAllData(initial.flat())
      ui.setLoader({ visible: false, text: '' })

      for (const month of allMonths.reverse()) {
        const next = await Promise.all(
          tipos.map(tipo =>
            businessAPI
              .getListSummaryMovements({
                type: tipo,
                businessId: currentBusiness.id,
                month,
                year: yearFilter,
                code: null,
                linkage: true
              })
              .then(res => res.data.map(item => ({ ...item, types: tipo })))
          )
        )
        setAllData(prev => [...prev, ...next.flat()])
      }
    } catch (err) {
      console.error(err)
      setAllData([])
      ui.setLoader({ visible: false, text: '' })
    }
  }
  useEffect(() => {
    getData()
  }, [currentBusiness?.id, meses, yearFilter])

  // statusOptions
  const statusOptions = useMemo(() => {
    const unique = Array.from(
      new Set(allData.map(m => m.status).filter(s => s != null && s !== '0'))
    )
    return [{ value: '', label: 'Todos' }, ...unique.map(s => ({ value: s, label: s }))]
  }, [allData])

  // razonSocialOptions
  const razonSocialOptions = useMemo(() => {
    const valores = allData
      .map(m => m.razonSocial)
      .filter(s => typeof s === 'string' && s.trim() !== '')
    const unique = Array.from(new Set(valores)).sort((a, b) =>
      a.localeCompare(b, undefined, { sensitivity: 'base' })
    )
    return [{ value: '', label: 'Todos' }, ...unique.map(s => ({ value: s, label: s }))]
  }, [allData])

  // filtrado y asociación banco
  const filteredData = useMemo(() => {
    const movimientos = allData.map(m => ({ ...m }))
    bankData.forEach(b => {
      const match = movimientos.find(m => m.comprobante === b.comprobante)
      if (match) match._banco = b
    })
    return movimientos
      .filter(m => {
        const f = dayjs(m.fecha)
        return f.isSameOrAfter(dayjs(filters.startDate)) && f.isSameOrBefore(dayjs(filters.endDate))
      })
      .filter(m => (statusFilter ? m.status === statusFilter : true))
      .filter(m => (typeFilter ? m.types === typeFilter : true))
      .filter(m => (razonSocialFilter ? m.razonSocial === razonSocialFilter : true))
  }, [allData, bankData, filters, statusFilter, typeFilter, razonSocialFilter])

  // preparar dataToExport
  // const dataToExport = filteredData.map(mov => {
  //   const totalAbono = (mov.linkage || []).reduce((sum, p) => sum + (p.montoAbono || 0), 0)
  //   const totalCargo = (mov.linkage || []).reduce((sum, p) => sum + (p.montoCargo || 0), 0)
  //   const movimiento = totalCargo > 0 ? totalCargo : totalAbono
  //   const tipoPago = totalCargo > 0 ? 'egreso' : totalAbono > 0 ? 'ingreso' : ''
  //   const saldo = Math.abs(mov.montoTotal - movimiento)
  //   const firstLink = (mov.linkage || [])[0] || {}
  //   const descripcionTipoPago = tipoMap[tipoPago] || ''
  //   // aquí mapeamos Clientes → ingreso, Proveedores → egresos
  //   const tipoPagoParaExportar = descripcionTipoPago === 'Clientes'
  //     ? 'ingreso'
  //     : descripcionTipoPago === 'Proveedores'
  //       ? 'egresos'
  //       : '-'
  

  //   return {
  //     Tipo: tipoMap[mov.types] || '',
  //     Fecha: dayjs(mov.fecha).format('DD/MM/YYYY'),
  //     'Rut / Razón': `${mov.rut} / ${mov.razonSocial}`,
  //     'Tipo Doc': obtenerAbreviatura(mov.nombreFolio),
  //     'N° Doc': mov.numeroFolio,
  //     'Tipo Comp.': mov.tipoComprobante,
  //     'N° Comp.': mov.comprobante,
  //     Monto: formatCLP(mov.montoTotal),
  //     Abono: formatCLP(totalAbono),
  //     Cargo: formatCLP(totalCargo),
  //     Saldo: formatCLP(saldo),
  //     'Tipo Pago': tipoPagoParaExportar,
  //     'N° Pago': firstLink.comprobante || '-',
  //     'Fecha Pago': firstLink.fechaPago ? dayjs(firstLink.fechaPago).format('DD/MM/YYYY') : '-',
  //     Descripción: firstLink.descripcion || '-',
  //     Status: mov.status || '-'
  //   }
  // })

  // íconos export
  const icons = [
    // <ExportCSV
    //   key='csv'
    //   currentBusiness={currentBusiness.name}
    //   rut={currentBusiness.rut}
    //   data={dataToExport}
    //   title='Resumen Conciliaciones'
    //   from={filters.startDate}
    //   to={filters.endDate}
    // />,
    // <ExportXLS
    //   key='xls'
    //   currentBusiness={currentBusiness.name}
    //   rut={currentBusiness.rut}
    //   data={dataToExport}
    //   title='Resumen Conciliaciones'
    //   from={filters.startDate}
    //   to={filters.endDate}
    // />,
    // <ExportPDF
    //   key='pdf'
    //   currentBusiness={currentBusiness.name}
    //   rut={currentBusiness.rut}
    //   data={dataToExport}
    //   title='Resumen Conciliaciones'
    //   from={filters.startDate}
    //   to={filters.endDate}
    // />
  ]

  return (
    <>
      <HeadingTitle title='Resumen Conciliaciones' rightIcons={icons} iconHeight={32} />
      {/* controles filtros */}
      <div className='mb-4'>
        <div className='flex flex-wrap gap-4 items-end'>
          <FilterDateControl
            label='Fecha Desde'
            value={filters.startDate}
            onChange={v => setFilters(f => ({ ...f, startDate: dayjs(v).format('YYYY-MM-DD') }))}
          />
          <FilterDateControl
            label='Fecha Hasta'
            value={filters.endDate}
            onChange={v => setFilters(f => ({ ...f, endDate: dayjs(v).format('YYYY-MM-DD') }))}
          />
          <FilterControl
            label='Status'
            value={statusFilter}
            onChange={setStatusFilter}
            options={statusOptions}
          />
          <FilterControl
            label='Tipo'
            value={typeFilter}
            onChange={setTypeFilter}
            options={typeOptions}
          />
          <FilterControl
            label='Razon Social'
            value={razonSocialFilter}
            onChange={setRazonSocialFilter}
            options={razonSocialOptions}
          />
        </div>
      </div>
      <TableMovimientos data={filteredData} getData={getData} />
    </>
  )
}
